/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_Denied_TitleInputs */

const en_portalframe_denied_title = /** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is not shared with you yet`)
};

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const ar_portalframe_denied_title = en_portalframe_denied_title;

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const he_portalframe_denied_title = en_portalframe_denied_title;

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const ur_portalframe_denied_title = en_portalframe_denied_title;

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const es_portalframe_denied_title = en_portalframe_denied_title;

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const fr_portalframe_denied_title = en_portalframe_denied_title;

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const de_portalframe_denied_title = en_portalframe_denied_title;

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const pt_portalframe_denied_title = en_portalframe_denied_title;

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const hi_portalframe_denied_title = en_portalframe_denied_title;

/** @type {(inputs: Portalframe_Denied_TitleInputs) => LocalizedString} */
const bn_portalframe_denied_title = en_portalframe_denied_title;

/**
* | output |
* | --- |
* | "This is not shared with you yet" |
*
* @param {Portalframe_Denied_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_denied_title = /** @type {((inputs?: Portalframe_Denied_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Denied_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_denied_title(inputs)
	if (locale === "he") return he_portalframe_denied_title(inputs)
	if (locale === "ur") return ur_portalframe_denied_title(inputs)
	if (locale === "es") return es_portalframe_denied_title(inputs)
	if (locale === "fr") return fr_portalframe_denied_title(inputs)
	if (locale === "de") return de_portalframe_denied_title(inputs)
	if (locale === "pt") return pt_portalframe_denied_title(inputs)
	if (locale === "hi") return hi_portalframe_denied_title(inputs)
	if (locale === "bn") return bn_portalframe_denied_title(inputs)
	return /** @type {LocalizedString} */ ("This is not shared with you yet")
});